/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})



document.querySelector('.look-product-view_btn')?.addEventListener('click', function() {
    document.querySelector('.shop-the_look-product-block').classList.toggle('show-product-look');
});

function initializeSplide() {
  const element = document.querySelector('#colectionsplide');
  if (element && !element.classList.contains('splide-initialized')) {
    const splide = new Splide('#colectionsplide', {
      type: 'loop',
      perPage: 2,
      autoplay: true,
      interval: 8000,
      flickMaxPages: 2,
      updateOnMove: true,
      pagination: false,
      throttle: 300,
      breakpoints: {
        767: {
          perPage: 1,
        },
      },
    });
    splide.mount();
    element.classList.add('splide-initialized');
  }
  const multielement = document.querySelector('#multi-featured-slider');
  if (multielement && !multielement.classList.contains('splide-initialized')) {
    const splide = new Splide('#multi-featured-slider', {
      type: 'loop',
      perPage: 3,
      autoplay: true,
      interval: 8000,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: false,
      throttle: 300,
      breakpoints: {
        991: {
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
    multielement.classList.add('splide-initialized');
  }
  const menuelement = document.querySelector('#offcanvas_menu_slider');
  if (menuelement && !menuelement.classList.contains('splide-initialized')) {
    const splide = new Splide('#offcanvas_menu_slider', {
      type: 'loop',
      perPage: 1,
      autoplay: true,
      interval: 8000,
      flickMaxPages: 1,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
    });
    splide.mount();
    menuelement.classList.add('splide-initialized');
  }
  const upSellelement = document.querySelector('#upsellsplide');
  if (upSellelement && !upSellelement.classList.contains('splide-initialized')) {
    const splide = new Splide('#upsellsplide', {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoplay: true,
      interval: 8000,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: false,
      padding: '10%',
      throttle: 300,
      breakpoints: {
        1440: {
          perPage: 1,
          padding: '30%',
        },
      },
    });
    splide.mount();
    upSellelement.classList.add('splide-initialized');
  }

  const collectionelement = document.querySelector('.collection-grid-slider');
  if (collectionelement && !collectionelement.classList.contains('splide-initialized')) {
    const splide = new Splide('.collection-grid-slider', {
      type: 'loop',
      perPage: 1,
      autoplay: true,
      interval: 8000,
      flickMaxPages: 1,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      padding: '10%',
    });
    splide.mount();
    collectionelement.classList.add('splide-initialized');
  }


}

function destroySplide() {
  const splideElement = document.querySelector('#colectionsplide.splide-initialized');
  if (splideElement) {
    const splideInstance = Splide.instances.get(splideElement);
    if (splideInstance) {
      splideInstance.destroy();
      splideElement.classList.remove('splide-initialized');
    }
  }
}
window.addEventListener("load", (event) => {
 initializeSplide();
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {

    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector('#colectionsplide')) {
          initializeSplide();
        }
      });
      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector('#colectionsplide')) {
          destroySplide();
        }
      });
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior if needed

        const dropdownMenu = this.nextElementSibling; // Select the corresponding dropdown menu
        const isOpen = dropdownMenu.style.height !== '0px' && dropdownMenu.style.height !== '';

        // Close all other dropdowns
        document.querySelectorAll('.dropdown-megamenu').forEach(menu => {
            menu.style.height = '0'; // Reset height
        });

        if (!isOpen) {
            // Open the clicked dropdown
            dropdownMenu.style.height = `${dropdownMenu.scrollHeight}px`;
        } else {
            // Close the clicked dropdown
            dropdownMenu.style.height = '0';
        }
    });
});

// Close dropdown when clicking outside
document.addEventListener('click', function (e) {
    const isDropdownClick = e.target.closest('.dropdown-item, .dropdown-megamenu, .dropdown-toggle');

    // If clicked outside of dropdowns
    if (!isDropdownClick) {
        document.querySelectorAll('.dropdown-megamenu').forEach(menu => {
            menu.style.height = '0'; // Close all dropdown menus
        });
    }
});

var CartNotificationDrawer = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
      this._onButtonClickListener = this._onButtonClick.bind(this);
  }
  connectedCallback() {  
  
    document.addEventListener("variant:add", this._onVariantAddedListener);
   this.addEventListener("click", this._onButtonClickListener)
  }
  disconnectedCallback() {
   
    document.removeEventListener("variant:add", this._onVariantAddedListener);
  }

_onVariantAdded(event) {
    const { cart } = event.detail;

    if (cart && cart.sections) {
        const content = cart.sections["variant-added"] || "<div>No content available</div>";
        const tempContent = document.createElement("div");
        tempContent.innerHTML = content;
        const shopifySection = tempContent.querySelector(".shopify-section");
        if (shopifySection) {
            this.replaceChildren(...shopifySection.children);
        } else {
            console.warn("No '.shopify-section' in 'variant-added' content");
        }
        this.show();
    } else {
        console.error("Cart sections or 'variant-added' is missing");
    }
}
 show() {
    this.classList.add("opened");    
    setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide() {
    this.classList.remove("opened");
    /*this.style.opacity = "0";
    setTimeout(() => {
      this.style.display = "none";
    }, 300);*/
  }
  _onButtonClick(event) {
    
      if (event.target.closest(".btn")) {
        this.hide();
      }
    }
};

//cart notification drower

// if (!window.customElements.get("cart-notification-drawer")) {
//   window.customElements.define("cart-notification-drawer", CartNotificationDrawer);
// }

document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.collection-header .description');
  if (!description) return;

  const collapsedHeight = 90;
  let fullHeight = 0;

  window.addEventListener('load', () => {
    fullHeight = description.scrollHeight;

    if (fullHeight <= collapsedHeight) {
      description.style.height = 'auto';
      return;
    }

    description.style.height = `${collapsedHeight}px`;

    const toggleButton = document.createElement('button');
    toggleButton.id = 'toggleDescription';
    toggleButton.className = 'read-more-btn';
    toggleButton.textContent = 'Read More';

    description.insertAdjacentElement('afterend', toggleButton);

    toggleButton.addEventListener('click', () => {
      if (description.style.height === `${collapsedHeight}px`) {
        description.style.height = `${fullHeight}px`;
        toggleButton.textContent = 'Read Less';
        toggleButton.classList.add('expanded');
      } else {
        description.style.height = `${collapsedHeight}px`;
        toggleButton.textContent = 'Read More';
        toggleButton.classList.remove('expanded');
      }
    });
  });
});



